import { useEffect, useState } from 'react';
import ContentWrapper from '../../views/components/ContentWrapper';
import { getUsers } from '../../data/dataApi';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Pagination from '../../views/components/Pagination';
import { roles } from '../../views/helpers';
import { useUserState } from '../../views/components/UserStateProvider';
import { IconChevronDown, IconChevronUp, IconSelector } from '@tabler/icons-react';

const UserAccounts = () => {
    const [lastUsedSortDirection, setLastUsedSortDirection] = useState("");

    const { userRole } = useUserState();

    const [users, setUsers] = useState([]);

    const { page } = useParams();

    const listLimit = 20;

    const navigate = useNavigate();

    useEffect(() => {
        (async () => {
            const response = await getUsers(page === undefined ? 0 : page - 1, lastUsedSortDirection);

            response.success && setUsers(response.data.rows);
        })();
    }, [page, lastUsedSortDirection]);

    return (
        <ContentWrapper className="scrollable">
            <div id="user-accounts" className="wrapper">
                {
                    userRole === "admin" &&
                    <div className="d-flex justify-content-end tif-pb-md-35 tif-pb-20">
                        <Link id="add-new-user-btn" to="/dashboard/user-accounts/add" className="dashboard-quinary-btn">+ <u>Add new user</u></Link>
                    </div>
                }
                <table className='primary-table'>
                    <thead>
                        <tr>
                            <td>Name</td>
                            <td>Email Address</td>
                            <td className="sortable-column" onClick={() => setLastUsedSortDirection(prevState => (prevState === "asc" ? "desc" : "asc"))}>Last Used {
                                lastUsedSortDirection ?
                                    lastUsedSortDirection === "asc" ?
                                        <IconChevronUp />
                                    :
                                        <IconChevronDown />
                                :
                                    <IconSelector />
                            }</td>
                            <td>Role</td>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            users.map((user) =>
                                <tr key={ user.id } onClick={() => navigate(`/dashboard/user-accounts/${ user.id }`)}>
                                    <td>{ user.name }</td>
                                    <td>{ user.email }</td>
                                    <td>{ user.last_used ? new Date(user.last_used).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : "N/A" }</td>
                                    <td>{ roles[user.role] }</td>
                                </tr>
                            )
                        }
                    </tbody>
                </table>

                <Pagination listLength={ users.length && users[0].total_count } path="/dashboard/user-accounts" page={ page } limit={ listLimit } />
            </div>
        </ContentWrapper>
    );
};

export default UserAccounts;
